import { render } from "./ClassReport.vue?vue&type=template&id=8d5fde66&scoped=true"
import script from "./ClassReport.vue?vue&type=script&lang=js"
export * from "./ClassReport.vue?vue&type=script&lang=js"

import "./ClassReport.vue?vue&type=style&index=0&id=8d5fde66&scoped=true&lang=css"

import exportComponent from "/var/www/html/dongan_teens2_check/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d5fde66"]])

export default __exports__